<template>
    <div class="analytics-select-filter">
        <ds-select-field
            v-model="filter.value"
            bind-value-only
            :options="filter.valueOptions"
        />
    </div>
</template>

<script>
export default {
    props: {
        value: Object,
    },

    data() {
        return {
            filter: this.value,
        };
    },

    watch: {
        value: {
            handler(value) {
                this.filter = value;
            },
            deep: true,
        },

        filter: {
            handler() {
                this.updateQuery();
            },
            deep: true,
        },

        'filter.modifier': function() {
            this.updateQuery();
        },
    },

    methods: {
        updateQuery() {
            let query = '';

            switch (this.filter.modifier) {
            case 'equals':
                query = this.filter.value;
                break;
            default:
                break;
            }

            this.filter.query = query;
        },
    },
};
</script>
